import React from "react";

import { Box } from "@chakra-ui/react";
import Select, { StylesConfig } from "react-select";
import { Maybe } from "utils/general/maybe";

import { Paragraph2 } from "ui/typography";

import { defaultStyledSelectStyles } from "./styles";
import { IStyledSelectProps } from "./types";

export const StyledSelect = (props: IStyledSelectProps) => {
  const {
    options,
    name,
    value,
    handleOnChange,
    label,
    labelClassName,
    placeholder,
    customStyles,
    menuPlacement,
    isSearchable,
    selectWrapperClassName,
    isDisabled,
    setIsMenuOpen,
  } = props;
  const styleConfig: StylesConfig = {
    ...defaultStyledSelectStyles,
    ...(customStyles && customStyles),
  };

  return (
    <Box className={`flex flex-col gap-2 ${selectWrapperClassName}`}>
      <Maybe condition={!!label}>
        <Paragraph2
          fontWeight="600"
          lineHeight="20px"
          textColor="#1A202C"
          className={labelClassName || ""}
        >
          {label}
        </Paragraph2>
      </Maybe>
      <Select
        placeholder={placeholder || ""}
        options={options}
        name={name}
        value={value}
        onChange={(value) => handleOnChange(value, name)}
        styles={styleConfig}
        menuPlacement={menuPlacement || "top"}
        isSearchable={isSearchable}
        isDisabled={isDisabled}
        onMenuOpen={() => setIsMenuOpen && setIsMenuOpen(true)}
        onMenuClose={() => setIsMenuOpen && setIsMenuOpen(false)}
      />
    </Box>
  );
};
